<template>
    <div class="wrap">
        <div class="coupons_box">
            <van-popup v-model="show"  @click-overlay="close_p" >
                <div class="coupons_box_tit">
                    <p>
                        <van-icon size="32" name="success" />
                    </p>
                    <p>{{this.source == 'exchange' ? '兑换成功' : '登录成功'}}</p>
                    <p>您已收到新的折扣券！</p>
                </div>
                <div class="voucher_wrap">
                    <ul class="f-clearfix">
                        <li v-for="(value,index) in user_coupons" :key="index">
                            <div class="coupon coupon-wave-left coupon-wave-right coupon-yes">
                                <van-col span="16" class="coupon-info coupon-hole coupon-info-right-dashed">
                                    <div class="coupon_price" v-if="value.type == 1">
                                        <div class="price_le"><span>￥</span>{{Number(value.discount_price).toFixed(0)}}</div>
                                    </div>
                                    <div class="coupon_price" v-if="value.type == 2">
                                        <div class="price_le">{{value.discount_rate * 10}}</div>
                                        <div class="price_ri">
                                            <p>%</p>
                                            <p>OFF</p>
                                        </div>
                                    </div>
                                    <div class="coupon_time">到期时间: {{value.expiration_time}}</div>
                                </van-col>
                                <van-col span="8" class="coupon-get">
                                    <div class="coupon_status">
                                        <p v-if="value.where_order_price > 0.00">结束 ￥{{value.where_order_price}}</p><p v-else>结束 ￥0.00</p>
                                    </div>
                                </van-col>
                            </div>
                        </li>
                    </ul>
                </div>
                <van-row type="flex" justify="center">
                    <van-col :span="12">
                        <van-button style="min-width: 90px; margin-top: 10px;" size="small" type="primary" @click="go">{{source == 'exchange' ? '立即使用' : '知道了'}}</van-button></van-col>
                </van-row>
            </van-popup>
        </div>
    </div>
</template>
<style>

    .coupons_box .van-popup {
        width: 80%;
        padding:10px 0 15px 0;
    }

    .coupons_box_tit p {
        text-align: center;
        color: #f35c9b;
        margin: 0 0 6px 0;
        font-size: 19px;
    }

    .coupons_box_tit p:last-child {
        font-size: 14px;
        color: #999;
        margin: 0;
    }

    .coupons_box_tit p:first-child {
        margin: 0;
    }
</style>
<script>
    // @ is an alias to /src
    export default {
        name: 'coupons-box',
        props:['user_coupons','source'],
        data() {
            return {
                show: true,
            }
        },
        methods: {
            go(){
                // if(this.source == 'close'){
                //     // this.$router.push('personal');
                //     this.$router.push(localStorage.getItem('reg_from'))
                //     this.user_coupons = [];
                // }else if(this.source == 'exchange'){
                //     this.$router.push('/')
                // }else{
                //     this.$router.push(localStorage.getItem('reg_from'))
                // }
                this.gourl_by_login();
            },
            close_p(){
                // this.$router.push(localStorage.getItem('reg_from'))
                this.go();
            },
        },
    }
</script>